export function PercentageFormat(realisasi, target) {
  return ((realisasi / target) * 100).toFixed(2);
}
